import { render, staticRenderFns } from "./petaInvestasi.vue?vue&type=template&id=7312ac97&"
import script from "./petaInvestasi.vue?vue&type=script&lang=js&"
export * from "./petaInvestasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QSelect,QItem,QItemSection,QCardActions,QImg,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QSelect,QItem,QItemSection,QCardActions,QImg})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
